<template>
  <v-btn
    color="primary"
    variant="flat"
    :prepend-icon="prependIcon"
    :disabled="props.disabled"
    @click="emit('primary-button-clicked')"
  >
    {{ ctaText }}
  </v-btn>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

type Props = {
  ctaText: string;
  isCreateCta?: boolean;
  isEditCta?: boolean;
  isMoveCta?: boolean;
  disabled?: boolean;
  isArchiveCta?: boolean;
  customIcon?: string;
};

type Emits = {
  'primary-button-clicked': [];
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const prependIcon = computed(() => {
  const { isCreateCta, isEditCta, isMoveCta, isArchiveCta, customIcon } = props;

  if (customIcon) return customIcon;
  if (isCreateCta) return 'mdi-plus';
  if (isEditCta) return 'mdi-pencil-outline';
  if (isMoveCta) return 'mdi-arrow-right';
  if (isArchiveCta) return 'mdi-archive';
  return '';
});
</script>
